package com.ijoin.platform

import kotlinx.browser.window

actual fun getDefaultPaymentReturnUrl(): String? = window.location?.href
